





















import { Component, Prop, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { api as deskApi } from "../../store/modules/desk";
import {
  Decks,
  ReleativOrderEntry,
  PlaceName,
} from "../../store/modules/desk/types";
import { TrickCard, Trick, FriendRef } from "@dokogd/shared";
import DoKoCard from "../../components/card/DoKoCard.vue";
import { Dictionary } from "lodash";

@Component({ components: { DoKoCard } })
export default class DoKoLastTrick extends Vue {
  readonly positions: { [p: string]: string } = {
    bottom: "rotate(-4.32) translate(549 384)",
    left: "rotate(262) translate(-519 430)",
    top: "rotate(4.84) translate(607 176)",
    right: "rotate(-85.2) translate(-370 632)",
  };

  @Getter(deskApi.getters.getRelativeOrder, { namespace: deskApi.namespace })
  relativeOrder!: ReleativOrderEntry[];

  @Getter(deskApi.getters.getLastTrick, { namespace: deskApi.namespace })
  currentTrick!: Trick;

  @Getter(deskApi.getters.getMappedUsers, { namespace: deskApi.namespace })
  mappedUser!: Dictionary<FriendRef>;

  get avatarId() {
    return this.mappedUser[this.currentTrick.owner]?.avatarId ?? "000";
  }

  get cards() {
    return this.currentTrick.cards.map((trickCard) => {
      const participantId = trickCard.participantId;
      const ro = this.relativeOrder.find(
        (r) => r.participantId === participantId
      );
      const place: PlaceName = ro ? ro.place : "bottom";
      return {
        name: trickCard.card,
        transform: this.positions[place],
      };
    });
  }
}
